import { render, staticRenderFns } from "./LazySelect.vue?vue&type=template&id=2d6f79fa&"
import script from "./LazySelect.vue?vue&type=script&lang=js&"
export * from "./LazySelect.vue?vue&type=script&lang=js&"
import style0 from "./LazySelect.vue?vue&type=style&index=0&id=2d6f79fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports